import { RemoteGetAllActivitiesByStudent } from 'data/usecases/dashboard';
import { GetAllActivitiesByStudent } from 'domain/usecases/dashboard';
import { makeApiUrlActivitiesByStudent } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByStudent = (): GetAllActivitiesByStudent =>
  new RemoteGetAllActivitiesByStudent(
    makeApiUrlActivitiesByStudent(),
    makeAxiosHttpClient(),
  );
